<script>
	import Modal from './Modal.svelte';
	import LeaderboardLine from './LeaderboardLine.svelte';
	import {countdown, formatedCountdown} from './Countdown.js';
	import * as animateScroll from "svelte-scrollto";
	import Cookies from 'js-cookie'
	import SlotMachine from './SlotMachine.svelte';
	import Notification from './Notification.svelte';
	import { onMount } from 'svelte';

	// TODO modularize / use components

	export let apiBaseUrl;
	let gcaptcha;
	let step = INIT
	let email;
	let nickname;
	let swelloConsent;
	let laMamaConsent;
	let modal;
	let showCaptcha = 'visibility:hidden';
	// replace with store
	let score = 0;
	let rank = 0;
	let gameId
	let lastScore
	let backgroundSound
	let notifier
	

	const LOGIN_MODAL = 'login'
	const REGISTER_MODAL = 'register'
	const GAMEOVER_MODAL = 'gameover'
	const INIT = 'init'
	const LOGGED = 'logged'
	const READY = 'ready'

	const openModal = (m) => {
		modal = m
	}

	const closeModal = () => {
		modal = undefined
	}

	const play = () => {
		// is user logged ? get from localstorage
		// else display login
		openModal(LOGIN_MODAL)
	}

	const jsonPost = async (url, data) => {
		const res = await fetch(url, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		});
		return await res.json()
	}

	const getPlayer = async () => {
		const resp = await jsonPost(`${apiBaseUrl}/rank`, {
			mail: email
		})
		if (resp.error) {
			notifier.display(resp.error.message)
		} else {
			score = resp.score
			rank = resp.rank
			nickname = resp.nickname
		}
	}

	// TODO add loading

	const endGame = (score, delay) => {
		step = LOGGED
		stepInGame = 0
		lastScore = score
		slotMachine.ensureStop()
		countdown.stop()
		getPlayer()
		setTimeout(() => {
			openModal(GAMEOVER_MODAL)
			if(lastScore <= 0){
				var myAudio = new Audio('./sounds/loose.mp3');
				myAudio.volume = 0.8;
				myAudio.play();
			}else if(lastScore > 0){
				var myAudio = new Audio('./sounds/win.mp3');
				myAudio.volume = 0.8;
				myAudio.play();
			}
		}, delay)
	}

	const countdownTimeout = () => {
		endGame(0, 0)
	}

	const goToGame = async(id) => {
		if(id=== 'need captcha'){
			showCaptcha = 'visibility:visible'
			if(gcaptcha!==undefined){
				gcaptcha = grecaptcha.reset()
			}
			return
		}
		step = READY
		gameId = id
	
		// TODO do not do it every game ?
		await getPlayer()
		countdown.setAndStart(60, countdownTimeout)
	}

	const login = async (silent) => {
		const anticache = new Date().getTime()
		const resp = await jsonPost(`${apiBaseUrl}/login`, {
			mail: email,
			c:anticache
		})
		if (resp.error && !silent) {
			notifier.display(resp.error.message)
		} else if (resp.gameId) {
			closeModal()
			goToGame(resp.gameId)
			saveSession(email)
		}
	}

	const register = async () => {
		const resp = await jsonPost(`${apiBaseUrl}/register`, {
			mail: email, nickname, allowSwello: swelloConsent, allowMama: laMamaConsent
		})
		if (resp.error) {
			notifier.display(resp.error.message)
		} else if (resp.gameId) {
			closeModal()
			goToGame(resp.gameId)
			saveSession(email)
		}
	}

	let stepInGame = 0
	let slotMachine
	const handleUserAction = async () => {
		if(step==LOGGED) {
			return login()
		} else if(step!=READY) {
			return
		}
		initSound()
		if(stepInGame==0) {
			slotMachine.start()
			stepInGame++;

			var myAudio = new Audio('./sounds/slot-machine.mp3');
			myAudio.volume = 0.8;
			myAudio.play();

			getLeaderboard();
		} else if(stepInGame < 4) {
			const resp = await jsonPost(`${apiBaseUrl}/play`, {
				gameId: gameId,
				step: stepInGame
			})

			slotMachine.stop(resp.clothes)
			if (resp.error) {
				notifier.display(resp.error.message)
			} else if(resp.final) {
				endGame(resp.points, 1500)
			}
		}
	}

	const handleClick = (event) => {
		if (event.target.closest('#play-sound')) return;
		handleUserAction()
	}

	const handleKeydown = async(event) => {
		if(event.keyCode == 32) {
			event.preventDefault() // should we use another key not related to a known browser shortcut ?
			handleUserAction()
		}
	}

	function getRandomInt(max) {
	  return Math.floor(Math.random() * Math.floor(max));
	}

	const initSound = () => {
		if(!backgroundSound) {
			var random = getRandomInt(2);
			backgroundSound = new Audio('./sounds/christmas-'+random+'.mp3');
			backgroundSound.volume = 0.6;
			backgroundSound.loop = true;
			backgroundSound.play();
		}
	}

	const toggleSound = () => {
		backgroundSound.paused ? backgroundSound.play() : backgroundSound.pause()
	}

	const goToLeaderboard = () => {
		getLeaderboard();
		closeModal();
		animateScroll.scrollTo({element: '#wrapper-ranking', offset: 200})
	}

	let leaderboard = []
	const getLeaderboard = async() => {
		const resp = await fetch(`${apiBaseUrl}/leaderboard`)
		leaderboard = await resp.json()
	}

	const COOKIE_NAME = 'christmas-game-email'
	const autologin = () => {
		const cookieEmail = Cookies.get(COOKIE_NAME)
		if (cookieEmail) {
			email = cookieEmail
			login(true)
		}
	}
	const saveSession = (email) => {
		Cookies.set(COOKIE_NAME, email, { expires: 1 });
	}

	const onSubmit = async (token) => {
		const resp = await jsonPost(`${apiBaseUrl}/captcha`, {
			mail: email,
			token
		})	
		if(resp){
			showCaptcha = 'visibility:hidden'
			login()
		}
	}
	onMount(() => {
		getLeaderboard()
		autologin()
		window.onSubmit = onSubmit
		window.onloadCallback = onloadCallback
	})
	// create initial captcha
	const onloadCallback = ()=> {
		gcaptcha = window.grecaptcha.render('hello', {sitekey:"6Lfuxf8ZAAAAACi_r_zdIsUR4pq41OKjHNOOJmd3", callback: onSubmit})
	}

</script>

<svelte:window on:keydown={handleKeydown}/>

<Notification bind:this={notifier}/>



{#if step != INIT}
<div id="wrapper-game">
	<div class="container only-mobile">
		<div id="game">
			<div id="game-top">
				 <div class="row">
					<div class="col-md-5">
						<strong class="no-mobile">Temps restant :</strong> {$formatedCountdown.min}:{$formatedCountdown.sec}
					</div>
					<div class="col-md-5 text-align-right">
						<strong class="no-mobile">Score :</strong> {score}  flocon{#if score > 1}s{/if} <span class="no-mobile">({rank}{#if rank == 1}ère{:else}ème{/if} place)</span><br>
						<div id="play-sound" on:click={toggleSound}>
							Son
							{#if !backgroundSound || backgroundSound.paused }
							 désactivé <span class="sprite-pms sprite-pms-sound-off"></span>
							{:else}
							 activé <span class="sprite-pms sprite-pms-sound-on"></span>
							{/if}
						</div>
					</div>
				</div>
			</div>
			<div id="game-background" on:click={handleClick}>
				<p class="sentence-space no-mobile">Appuyez <strong>sur espace</strong> pour jouer !</p>
				<p class="sentence-space mobile"> <strong>Touchez</strong> pour jouer !</p>
			</div>
			<SlotMachine bind:this={slotMachine}/>
			<div id="game-inner"></div>
		</div>
	</div>
</div>
{:else}
<div id="wrapper-header">
	<div class="container">
		<div id="wrapper-header-zindex">
			<div class="row">
				<div class="col-md-7 col-sm-6">
					<span class="sprite-pms sprite-pms-arrow"></span>
					<h1>Habillez correctement<br class="no-br"> cet élégant Père Noël & gagnez<br class="no-br"> l’un des 10 lots mis en jeu !</h1>
					<p class="main-subtitle">Jeu de Noël, du 8 au 17 décembre 2020</p>
					<span class="btn btn-float" on:click="{() => openModal(REGISTER_MODAL)}">Et c’est parti !</span>
				</div>
				<div class="col-md-3 col-sm-4">
					<div id="game-front">
						<div id="game-background"></div>
						<div id="game-santa">
							<div id="santa-top">
								<img src="./img/imgs-splittees/top/1.png" width="290" alt="Père Noël">
							</div>
							<div id="santa-middle">
								<img src="./img/imgs-splittees/middle/1.png" width="290" alt="Père Noël">
							</div>
							<div id="santa-btm">
								<img src="./img/imgs-splittees/btm/1.png" width="290" alt="Père Noël">
							</div>
						</div>
						<div id="game-inner"></div>
					</div>
				</div>
			</div>
		</div>
		<span class="sprite-pms-illus sprite-pms-tree"></span>
	</div>
</div>
{/if}


<div id="wrapper-team">
	<div class="container">
		<ul>
			<li>
				<a href="https://swello.com/fr/decouvrir-la-plateforme?utm_tag=pimpmysanta" title="Découvrez Swello, l'outil de Social Media management français !" target="_blank">
					<span class="sprite-pms sprite-pms-swello"></span>
				</a>
			</li>
			<li class="wrapper-team_spacing">x</li>
			<li>
				<a href="https://lamama.fr/" title="Agence de production de films publicitaires" target="_blank">
					<span class="sprite-pms sprite-pms-lamama"></span>
				</a>
			</li>
			<li class="wrapper-team_spacing">x</li>
			<li>
				<a href="http://thomasgabelle.fr/projets" title="Créateur de jolies musiques 🎶" target="_blank">
					<span class="sprite-pms sprite-pms-thomas"></span>
				</a>
			</li>
		</ul>
	</div>
</div>

<div id="wrapper-how-to-play">
	<div class="container">
		<h2>Comment jouer ?</h2>
		<p class="subtitle">Quelques règles simples à connaître</p>
	
		<div class="row">
			<div class="col-md-33">
				<span class="how-to-play-illustration">
					<span class="sprite-pms-illus sprite-pms-santa-nude-small"></span>
				</span>
				<span class="how-to-play-sentence">Habillez le Père Noël <strong>en appuyant sur espace</strong>, avant qu’il ne saute dans son traineau</span>
			</div>
			<div class="col-md-33">
				<span class="how-to-play-illustration">
					<span class="sprite-pms-illus sprite-pms-snowflake-small"></span>
				</span>
				<span class="how-to-play-sentence">Pour chaque tenue assemblée, <strong>vous gagnez des flocons</strong>, sinon, vous en perdez</span>
			</div>
			<div class="col-md-33">
				<span class="how-to-play-illustration">
					<span class="sprite-pms-illus sprite-pms-gift-purple-small"></span>
				</span>
				<span class="how-to-play-sentence">Les 10 joueurs ayant rassemblés le plus de flocons le <strong>17/12 à 23h59</strong>, gagneront un lot</span>
			</div>
		</div>
	</div>
</div>

<div id="wrapper-partners" class="wrapper-partners-landing">
	<div class="container">
		 <div class="row">
			<div class="col-md-7">
				<h2>Découvrez les magnifiques lots à gagner</h2>
				<p class="subtitle">
					<strong>10 superbes entreprises françaises</strong> ont décidé de vous gâter<br class="no-br"> avec plus de <strong>1300€ de lots</strong> (c’est énooorme) !
				</p>
			</div>
			<div class="col-md-3">
				<span class="sprite-pms-illus sprite-pms-here"></span>
			</div>
		</div>

		<div class="row">
			 <div class="col-md-33">
				<a href="https://bit.ly/cabaia-swello" title="Cabaïa réinvente les accessoires et vêtements pour les femmes, hommes et enfants : Bonnets, Écharpes, Chaussettes, Tongs, Serviettes de plage, Sacs" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">cabaïa</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-cabaia"></span>
						</span>
						<span class="wrapper-partner_product">1 bonnet & 3 paires de chaussettes inséparables</span>
						<span class="wrapper-partner_price">Valeur 60,00€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-cabaia"></span>
						</span>
					</span>
				</a>
			 </div>

			 <div class="col-md-33">
				<a href="https://swll.to/ulysse-travel" title="Réservez un vol pas cher avec Ulysse, comparateur de vol nouvelle génération. Achetez des billets d'avion pour des milliers de destinations à travers le monde." target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">ulysse</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-ulysse"></span>
						</span>
						<span class="wrapper-partner_product">1 carte cadeau <br class="no-br">de billets d’avion</span>
						<span class="wrapper-partner_price">Valeur 120,00€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-ulysse"></span>
						</span>
					</span>
				</a>
			 </div>

			 <div class="col-md-33">
				<a href="https://swll.to/lovebox" title="Objet connecté au pouvoir émotionnel immense" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">lovebox</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-lovebox"></span>
						</span>
						<span class="wrapper-partner_product">1 Lovebox, coffret couleur <br class="no-br">& photo</span>
						<span class="wrapper-partner_price">Valeur 119,99€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-lovebox"></span>
						</span>
					</span>
				</a>
			 </div>
		 </div>

		 <div class="row">
			 <div class="col-md-33">
				<a href="https://swll.to/tuto-com" title="Tuto et Formation Photoshop, After Effects, Photo, Lightroom, PHP en vidéo" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">tuto.com</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-tuto"></span>
						</span>
						<span class="wrapper-partner_product">1 abonnement de 1 an pour se former au digital</span>
						<span class="wrapper-partner_price">Valeur 358,80€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-tuto"></span>
						</span>
					</span>
				</a>
			 </div>

			 <div class="col-md-33">
				<a href="https://swll.to/ngo-shoes" title="Baskets éthiques et éco-responsables" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">n'go shoes</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-ngo"></span>
						</span>
						<span class="wrapper-partner_product">1 paire de chaussure éthnique et éthique au choix</span>
						<span class="wrapper-partner_price">Valeur 110,00€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-ngo"></span>
						</span>
					</span>
				</a>
			 </div>

			 <div class="col-md-33">
				<a href="https://swll.to/aromandise" title="Aromandise développe et distribue des senteurs naturelles, encens et épices bio" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">aromandise</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-aromandise"></span>
						</span>
						<span class="wrapper-partner_product">1 pack bien-être (tisanes, bougie, livre…)</span>
						<span class="wrapper-partner_price">Valeur 70,00€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-aromandise"></span>
						</span>
					</span>
				</a>
			 </div>
		 </div>

		 <div class="row">
			 <div class="col-md-33">
				<a href="https://swll.to/indemne" title="Cosmétiques naturels et bio aux huiles essentielles" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">indemne</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-indemne"></span>
						</span>
						<span class="wrapper-partner_product">1 box cosmétique, cure hivernale</span>
						<span class="wrapper-partner_price">Valeur 52,30€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-indemne"></span>
						</span>
					</span>
				</a>
			 </div>

			 <div class="col-md-33">
				<a href="https://swll.to/photoweb" title="Photoweb : le site d'impression photo facile & rapide !" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">photoweb</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-photoweb"></span>
						</span>
						<span class="wrapper-partner_product">1 bon d’achat utilisable sur l’ensemble du site</span>
						<span class="wrapper-partner_price">Valeur 50,00€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-photoweb"></span>
						</span>
					</span>
				</a>
			 </div>

			 <div class="col-md-33">
				<a href="https://swll.to/marvin-chin" title="Marvin Chín - Illustrateur varois" target="_blank" class="wrapper-partner-link">
					<span class="wrapper-partner">
						<span class="wrapper-partner_name_align">
							<span class="wrapper-partner_name">marvin chin</span>
						</span>
						<span class="wrapper-partner_img">
							<span class="sprite-pms-products sprite-pms-products-marvin"></span>
						</span>
						<span class="wrapper-partner_product">1 affiche « Egypte », <br class="no-br"> 1 totebag & des stickers</span>
						<span class="wrapper-partner_price">Valeur 45,00€ TTC</span>

						<span class="wrapper-partner_logo">
							<span class="sprite-pms sprite-pms-marvin"></span>
						</span>
					</span>
				</a>
			 </div>
		 </div>

		 <a href="https://swello.com/fr/decouvrir-la-plateforme?utm_tag=pimpmysanta" title="Découvrez Swello, l'outil de Social Media management français !" target="_blank" class="wrapper-partner-link">
			<span class="wrapper-partner">
				<span class="wrapper-partner_name_align">
					<span class="wrapper-partner_name">swello</span>
				</span>
				<span class="wrapper-partner_product no-margin">1 abonnement Swello Large Annuel + pour les 10 premiers des stickers Swello</span>
				<span class="wrapper-partner_price">Valeur 430,56€ TTC</span>
			</span>
		</a>

		 <div class="wrapper-partners-bottom">
			<p>Plutôt sympa pour faire plaisir à vos collègues ! Non ?</p>
			<span class="btn btn-white" on:click="{() => openModal(REGISTER_MODAL)}">Je joue sans attendre</span>
		</div>
	</div>
</div>

<div id="wrapper-ranking">
	<div class="container">
		<h2>Classement</h2>
		<p class="subtitle">Qui seront les 10 meilleurs lutins ?</p>

		<div id="wrapper-ranking_table-zindex">
			<span class="sprite-pms-illus sprite-pms-gift-yellow-small"></span>
			<span class="sprite-pms-illus sprite-pms-gift-purple"></span>

			<div class="wrapper-ranking_table">
				<div class="row">
					<div class="col-md-5 padding-right-40">
						<LeaderboardLine player="{leaderboard[0]}" rank="1" />
						<LeaderboardLine player="{leaderboard[1]}" rank="2" />
						<LeaderboardLine player="{leaderboard[2]}" rank="3" />
						<LeaderboardLine player="{leaderboard[3]}" rank="4" />
						<LeaderboardLine player="{leaderboard[4]}" rank="5" />
					</div>
					<div class="col-md-5 padding-left-40">
						<LeaderboardLine player="{leaderboard[5]}" rank="6" />
						<LeaderboardLine player="{leaderboard[6]}" rank="7" />
						<LeaderboardLine player="{leaderboard[7]}" rank="8" />
						<LeaderboardLine player="{leaderboard[8]}" rank="9" />
						<LeaderboardLine player="{leaderboard[9]}" rank="10" />
					</div>
				</div>
				{#if nickname}
				<div class="row">
					<div class="col-md-offset-25 col-md-5 wrapper-line-mine">
						<span class="wrapper-ranking_table-line wrapper-ranking_table-line-mine no-border">
							<span class="wrapper-ranking_table-line_rank">{rank}</span>
							<span class="wrapper-ranking_table-line_pseudo">{nickname} <span class="no-weight">(vous)</span></span>
							<span class="wrapper-ranking_table-line_snowflake">{score} flocons</span>
						</span>
					</div>
				</div>
				{/if}
				<span class="wrapper-ranking_table_btn">
					<span class="btn btn-float" on:click="{play}">Je (re)-joue !</span>
				</span>
			</div>
			<span class="sprite-pms-illus sprite-pms-gift-yellow"></span>
		</div>
	</div>
</div>

<footer>
	<div class="container">
		<ul>
			<li>
				<a href="https://swello.com/fr/decouvrir-la-plateforme?utm_tag=pimpmysanta" title="Découvrez Swello, l'outil de Social Media management français !" target="_blank">
					<span class="sprite-pms sprite-pms-swello-grey"></span>
				</a>
			</li>
			<li class="footer-team_spacing">x</li>
			<li>
				<a href="https://lamama.fr/" title="Agence de production de films publicitaires" target="_blank">
					<span class="sprite-pms sprite-pms-lamama-grey"></span>
				</a>
			</li>
			<li class="footer-team_spacing">x</li>
			<li>
				<a href="http://thomasgabelle.fr/projets" title="Créateur de jolies musiques 🎶" target="_blank">
					<span class="sprite-pms sprite-pms-thomas-grey"></span>
				</a>
			</li>
		</ul>
		<br>
		<a href="https://drive.google.com/file/d/1YHBWby1WQetVVBG-PNUiapckPfkoYgKi/view?usp=sharing" title="Découvrez le réglement du jeu !" target="_blank" class="no-margin-left">Réglement du jeu</a> 
		<a href="https://swello.com/fr/mentions-legales" title="Mentions légales" target="_blank">Mentions légales</a> 
		<a href="https://swello.com/fr/politique-de-confidentialite" title="Politique de confidentialité" target="_blank">Politique de confidentialité</a>
		<br>
		<a href="mailto:support@swello.com" title="Contactez-nous !" class="need-game no-margin-left">Vous souhaitez créer un super jeu pour votre marque ?</a>
	</div>
</footer>

{#if modal == LOGIN_MODAL}
<Modal on:close={closeModal}>
	<h2>Rejoignez le plus grand<br class="no-br"> tournoi de lutins !</h2>
	<span class="modal-subtitle">Jeu de Noël, du 8 au 17 décembre</span>
	<input type="text" maxlength="42" class="im-input" bind:value={email} placeholder="Votre adresse email professionnelle*">

	<span class="btn" on:click="{login}">Et c'est (re)parti !</span>

	<span slot="footer" class="modal-footer false-link" on:click="{() => openModal(REGISTER_MODAL)}">
		<strong>Je n'ai pas encore de compte</strong>
	</span>

	<span class="sprite-pms-illus sprite-pms-gift-yellow-medium"></span>
</Modal>
{:else if modal == REGISTER_MODAL}
<Modal on:close={closeModal}>
	<h2>Rejoignez le plus grand<br class="no-br"> tournoi de lutins !</h2>
	<span class="modal-subtitle">Jeu de Noël, du 8 au 17 décembre</span>

	<input type="text" maxlength="14" class="im-input input-margin-btm" bind:value={nickname} placeholder="Votre pseudo*">
	<input type="text" maxlength="42" class="im-input" bind:value={email} placeholder="Votre adresse email professionnelle*">
	<label>
		<input type="checkbox" bind:checked={swelloConsent}>
		J'accepte d'être recontacté par Swello
	</label>
	<label class="input-margin-btm">
		<input type="checkbox" bind:checked={laMamaConsent}>
		J'accepte d'être recontacté par La Mama Studio
	</label>

	<span class="btn" on:click="{register}">Et c'est parti !</span>
	<span class="modal-rules">En cliquant sur le bouton "Et c'est parti", vous acceptez <a href="https://drive.google.com/file/d/1YHBWby1WQetVVBG-PNUiapckPfkoYgKi/view?usp=sharing" class="false-link" title="" target=""><strong>le règlement du jeu</strong></a>.</span>

	<span slot="footer" class="modal-footer false-link" on:click="{() => openModal(LOGIN_MODAL)}">
		<strong>J’ai déjà un compte</strong><br class="just-mobile"> (et je suis un super lutin)
	</span>

	<span class="sprite-pms-illus sprite-pms-gift-yellow-medium"></span>
</Modal>
{:else if modal == GAMEOVER_MODAL}
<Modal on:close={closeModal}>
	{#if lastScore > 0}
		<h2>Bien joué, +{lastScore} points !</h2>
	{:else if lastScore == 0}
		<h2>Ouf, {lastScore} point !</h2>
	{:else if lastScore == -1}
		<h2>Oups, {lastScore} point...</h2>
	{:else}
		<h2>Hum, {lastScore} points...</h2>
	{/if}
	<p class="modal-snowflakes"><strong>Vous êtes à la {rank}{#if rank == 1}ère{:else}ème{/if} place !</strong><br>Malheureusement, depuis le 18/12, le jeu est terminé !</p>
	<span class="btn" on:click="{login}">Je re-joue !</span>

	<span slot="footer" class="modal-footer false-link" on:click="{goToLeaderboard}"><strong>Je m’arrête là, allons voir le classement général</strong></span>
</Modal>
{/if}
	<div style={showCaptcha}>
		<div class="modal-background"></div>
		<div class="modal" role="dialog" aria-modal="true" >
		<h2>Êtes-vous un lutin malveillant ?</h2>
		<div id="hello"></div>
	</div>
</div>